import React from "react";

const WhatsappIcon = () => (
  <i
    className="fa-brands fa-whatsapp fs-6 me-1 fw-bold text-success"
    aria-hidden="true"
  />
);

const WhatsappOtpLabel = () => (
  <span className="fw-bold text-success">WhatsApp OTP</span>
);

/**
 * @param {object} props
 * @param {"will_be_sent" | "sent_to"} props.variant
 * @param {string} [props.mobile] — required when variant is sent_to
 * @param {string} [props.className]
 */
const StoreWhatsappOtpHint = ({
  variant,
  mobile = "",
  className = "d-block mt-2 pb-1",
}) => {
  if (variant === "sent_to") {
    return (
      <div className={className}>
        <WhatsappIcon />
        <WhatsappOtpLabel /> sent to <b>{mobile}</b>
      </div>
    );
  }

  return (
    <div className={className}>
      <WhatsappIcon />
      <WhatsappOtpLabel /> will be sent to this number
    </div>
  );
};

export default StoreWhatsappOtpHint;
